import { render, staticRenderFns } from "./ApplyBill.vue?vue&type=template&id=52a12a57&scoped=true&"
import script from "./ApplyBill.vue?vue&type=script&lang=js&"
export * from "./ApplyBill.vue?vue&type=script&lang=js&"
import style0 from "./ApplyBill.vue?vue&type=style&index=0&id=52a12a57&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a12a57",
  null
  
)

export default component.exports